import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function fetchAcademyClasses() {
  const q = query(collection(db, 'academy_classes'), orderBy('createdAt', 'asc'));
  const snap = await getDocs(q);
  const groups = {};
  snap.forEach((d) => {
    const data = d.data();
    const mId = data.moduleId || 'GERAL';
    if (!groups[mId]) {
      groups[mId] = {
        id: mId,
        title: data.moduleTitle || 'Módulo Geral',
        lessons: [],
      };
    }
    groups[mId].lessons.push({ id: d.id, ...data });
  });
  return Object.values(groups);
}
